document.addEventListener("DOMContentLoaded",()=>{

const btn=document.getElementById("check-btn");
const input=document.getElementById("pincode");
const result=document.getElementById("delivery-result");

if(!btn || !input || !result) return;


// Restore previous data

const savedPin=localStorage.getItem("pb_pincode");
const savedResult=localStorage.getItem("pb_delivery_result");

if(savedPin){
input.value=savedPin;
}

if(savedResult){
result.innerHTML=savedResult;
}


// Enter key support

input.addEventListener("keydown",(e)=>{

if(e.key==="Enter"){

e.preventDefault();

btn.click();

}

});


// Main click handler

btn.addEventListener("click",async()=>{

const pin=input.value.trim();

if(pin.length!==6){

result.innerHTML=`
<div class="pb-error-box">
Please enter a valid pincode
</div>
`;

return;

}

result.innerHTML=`
<div class="pb-loading">
Checking delivery...
</div>
`;

try{

const response=await fetch(
`https://project-gkmus.vercel.app/api/pincode-check?pin=${pin}`
);

const data=await response.json();

if(data.available){

result.innerHTML=`

<div class="pb-success-box">

<div class="pb-success-icon">
✓
</div>

<div class="pb-success-content">

<div class="pb-success-title">
Great News! We deliver to your location
</div>

<div class="pb-success-days">
Estimated Delivery: ${data.delivery_days}
</div>

<div class="pb-success-note">
Safe & secure delivery across India
</div>

</div>

</div>
`;

localStorage.setItem(
"pb_pincode",
pin
);

localStorage.setItem(
"pb_delivery_result",
result.innerHTML
);

}else{

result.innerHTML=`
<div class="pb-error-box">
Sorry! Delivery unavailable.
</div>
`;

}

}catch{

result.innerHTML=`
<div class="pb-error-box">
Something went wrong.
</div>
`;

}

});

});